import React, { useContext } from "react";
import { numberWithCommas } from "../../../../utils/common";
import { COMBO_LIST } from "../../../../config/constants";
import styled from "styled-components";
import { ContestContext } from "../../../../App";

const ComboVote = ({ comboVoteOrder = [], setComboVote, onClose }) => {
  const { contest } = useContext(ContestContext);

  const handAddComboVote = (comboID, qty, newValue) => {
    const newOrder = comboVoteOrder.map((p) => {
      if (p.comboID === comboID) {
        const newQty =
          newValue != undefined
            ? newValue
            : p.comboQty + qty > 0
            ? p.comboQty + qty
            : 0;
        return { ...p, comboQty: newQty };
      }

      return p;
    });

    setComboVote(newOrder);
  };

  return (
    <Styles>
      {contest?.comboList?.map((combo, ind) => {
        return (
          <div
            key={ind}
            onClick={() => {}}
            className={"cb-border"}
            style={
              comboVoteOrder.some(
                (c) => c.comboID === combo.id && c.comboQty > 0
              )
                ? { borderColor: "#5d8aa8" }
                : {}
            }
          >
            <p
              style={{
                textAlign: "center",
                fontWeight: "600",
                fontSize: "16px",
              }}
            >
              {combo.point} điểm
            </p>

            <p
              style={{
                textAlign: "center",
                fontSize: "16px",
              }}
            >
              {" "}
              {numberWithCommas(combo.price)}đ
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                className="cursor-pointer"
                onClick={() => handAddComboVote(combo.id, -1)}
              >
                <g clipPath="url(#clip0_5325_6771)">
                  <path
                    d="M10.5 18C14.6421 18 18 14.6421 18 10.5C18 6.35786 14.6421 3 10.5 3C6.35786 3 3 6.35786 3 10.5C3 14.6421 6.35786 18 10.5 18Z"
                    stroke={`${
                      comboVoteOrder.some(
                        (c) => c.comboID === combo.id && c.comboQty > 0
                      )
                        ? "#5d8aa8"
                        : "#C1C7CD"
                    }`}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8.14258 10.5H12.8566"
                    stroke={`${
                      comboVoteOrder.some(
                        (c) => c.comboID === combo.id && c.comboQty > 0
                      )
                        ? "#5d8aa8"
                        : "#C1C7CD"
                    }`}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_5325_6771">
                    <rect
                      width="20"
                      height="20"
                      fill="white"
                      transform="translate(0.5 0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>

              {/* {
                <p className="text-[18px]">
                  {comboVoteOrder.filter((c) => c.comboID === combo.id).length >
                    0 &&
                    comboVoteOrder.filter((c) => c.comboID === combo.id)[0]
                      .comboQty}
                </p>
              } */}
              {
                <input
                  type="number"
                  className="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none focus:outline-none w-[30px] text-center text-[18px]"
                  defaultValue={0}
                  inputMode="numeric"
                  value={`${
                    comboVoteOrder.filter((c) => c.comboID === combo.id)
                      .length > 0 &&
                    comboVoteOrder.filter((c) => c.comboID === combo.id)[0]
                      .comboQty
                  }`}
                  onChange={(e) =>
                    handAddComboVote(combo.id, 0, Number(e.target.value))
                  }
                />
              }

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                onClick={() => handAddComboVote(combo.id, 1)}
              >
                <g clipPath="url(#clip0_5325_6793)">
                  <path
                    d="M10 18C14.1421 18 17.5 14.6421 17.5 10.5C17.5 6.35786 14.1421 3 10 3C5.85786 3 2.5 6.35786 2.5 10.5C2.5 14.6421 5.85786 18 10 18Z"
                    stroke="#5d8aa8"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9.9996 8.14298V12.857M7.64258 10.5H12.3566H7.64258Z"
                    stroke="#5d8aa8"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_5325_6793">
                    <rect
                      width="20"
                      height="20"
                      fill="white"
                      transform="translate(0 0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        );
      })}
    </Styles>
  );
};

// grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-[14px] lg:gap-[20px] mt-[12px] px-[20px] sm:px-[0px]
const Styles = styled.div`
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: 12px 20px 0 20px;

  .cb-border {
    padding: 20px 8px 20px 8px;
    border: solid 1px #fff;
    border-radius: 6px;
    cursor: pointer;
    transition-duration: 150ms;

    :hover {
      border-color: #5d8aa8;
    }
  }

  @media only screen and (max-width: 640px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;

export default ComboVote;
